import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formats any date value as the Indian-style "14 Jun 2026".
 * Use across the app for a single, consistent date format.
 *
 *   {{ value | indDate }}            -> 14 Jun 2026
 *   {{ value | indDate:true }}       -> 14 Jun 2026, 5:30 pm   (with time)
 *   {{ null  | indDate }}            -> —
 */
@Pipe({ name: 'indDate', standalone: true })
export class IndDatePipe implements PipeTransform {
  transform(value: string | number | Date | null | undefined, withTime = false, fallback = '—'): string {
    if (value === null || value === undefined || value === '') return fallback;

    // Accept "yyyy-MM-dd" and "yyyy-MM-ddTHH:mm:ss" (treat the latter's time as-is).
    // A date-ONLY ISO string is parsed as UTC midnight by `new Date()`, which renders as the
    // PREVIOUS day for viewers west of UTC — anchor it to local midnight instead.
    let d: Date;
    if (value instanceof Date) {
      d = value;
    } else if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
      d = new Date(value + 'T00:00:00');
    } else {
      d = new Date(value);
    }
    if (isNaN(d.getTime())) return fallback;

    const dateOpts: Intl.DateTimeFormatOptions = { day: '2-digit', month: 'short', year: 'numeric' };
    if (!withTime) return new Intl.DateTimeFormat('en-IN', dateOpts).format(d);

    return new Intl.DateTimeFormat('en-IN', {
      ...dateOpts,
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    }).format(d);
  }
}
